export function removeNbspPTag() {
    let elements = document.getElementsByTagName('p');
    let element;
    for (let i = elements.length - 1; i >= 0; i--) {
        element = elements[i];
        let contents = element.innerHTML;
        contents = contents.replace(/(&nbsp;|\s|\n|\r|\t)+/gi, '');
        if (contents.length === 0) {
            element.parentNode.removeChild(element);
        }
    }
}
